"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuill = _interopRequireWildcard(require("react-quill"));
var _quillDelta = _interopRequireDefault(require("quill-delta"));
var _classnames = _interopRequireDefault(require("classnames"));
var _EDSContext = require("../EDSContext/EDSContext");
var _useEditorStyles = _interopRequireDefault(require("./styles/useEditorStyles"));
var _useRendererStyles = _interopRequireDefault(require("./styles/useRendererStyles"));
var _AlignCenter = _interopRequireDefault(require("@ellucian/ds-icons/lib/AlignCenter"));
var _AlignJustify = _interopRequireDefault(require("@ellucian/ds-icons/lib/AlignJustify"));
var _AlignLeft = _interopRequireDefault(require("@ellucian/ds-icons/lib/AlignLeft"));
var _AlignRight = _interopRequireDefault(require("@ellucian/ds-icons/lib/AlignRight"));
var _QuoteRight = _interopRequireDefault(require("@ellucian/ds-icons/lib/QuoteRight"));
var _Bold = _interopRequireDefault(require("@ellucian/ds-icons/lib/Bold"));
var _ClearFormatting = _interopRequireDefault(require("@ellucian/ds-icons/lib/ClearFormatting"));
var _Direction = _interopRequireDefault(require("@ellucian/ds-icons/lib/Direction"));
var _DirectionRtl = _interopRequireDefault(require("@ellucian/ds-icons/lib/DirectionRtl"));
var _Font = _interopRequireDefault(require("@ellucian/ds-icons/lib/Font"));
var _Indent = _interopRequireDefault(require("@ellucian/ds-icons/lib/Indent"));
var _Image = _interopRequireDefault(require("@ellucian/ds-icons/lib/Image"));
var _Italic = _interopRequireDefault(require("@ellucian/ds-icons/lib/Italic"));
var _Link = _interopRequireDefault(require("@ellucian/ds-icons/lib/Link"));
var _ListOl = _interopRequireDefault(require("./internal/ListOl"));
var _Outdent = _interopRequireDefault(require("@ellucian/ds-icons/lib/Outdent"));
var _Strikethrough = _interopRequireDefault(require("@ellucian/ds-icons/lib/Strikethrough"));
var _Subscript = _interopRequireDefault(require("@ellucian/ds-icons/lib/Subscript"));
var _Superscript = _interopRequireDefault(require("@ellucian/ds-icons/lib/Superscript"));
var _Underline = _interopRequireDefault(require("@ellucian/ds-icons/lib/Underline"));
var _Undo = _interopRequireDefault(require("@ellucian/ds-icons/lib/Undo"));
var _ListView = _interopRequireDefault(require("@ellucian/ds-icons/lib/ListView"));
var _VariableData = _interopRequireDefault(require("@ellucian/ds-icons/lib/VariableData"));
var _Video = _interopRequireDefault(require("@ellucian/ds-icons/lib/Video"));
var _Redo = _interopRequireDefault(require("@ellucian/ds-icons/lib/Redo"));
var _LinkPopper = _interopRequireDefault(require("./internal/LinkPopper"));
var _ImagePopper = _interopRequireDefault(require("./internal/ImagePopper"));
var _ImageResize = _interopRequireDefault(require("./internal/QuillImageResizer/ImageResize"));
var _VideoPopper = _interopRequireDefault(require("./internal/VideoPopper"));
var _SubstitutionVariablesPopper = _interopRequireDefault(require("./internal/SubstitutionVariablesPopper"));
var _CustomHeaderBlot = _interopRequireDefault(require("./blots/CustomHeaderBlot"));
var _LinkBlot = _interopRequireWildcard(require("./blots/LinkBlot"));
var _CustomImageBlot = _interopRequireDefault(require("./blots/CustomImageBlot"));
var _CustomVideoBlot = _interopRequireDefault(require("./blots/CustomVideoBlot"));
var _SubstitutionVariablesBlot = _interopRequireDefault(require("./blots/SubstitutionVariablesBlot"));
var _excluded = ["className", "toolbar", "edsContext", "disableLinkTargets", "readOnly"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * This Attributor lets us separate the target attribute from the link blot.
 * This is necessary since inline formats (like links) are best supported by Quill's APIs when only returning one attribute.
 *
 * The Attributor returns the value of target attribute from the link's anchor tag.
 */
var Parchment = _reactQuill.Quill.import('parchment');
var LinkTarget = new _LinkBlot.LinkTargetAttributor('target', 'target', {
  scope: Parchment.Scope.INLINE_BLOT
});
// override Quill's formats and modules with our own custom implementations
_reactQuill.Quill.debug('error');
_reactQuill.Quill.register('modules/imageResize', _ImageResize.default);
_reactQuill.Quill.register('formats/header', _CustomHeaderBlot.default);
_reactQuill.Quill.register('formats/link', _LinkBlot.default);
_reactQuill.Quill.register('formats/image', _CustomImageBlot.default);
_reactQuill.Quill.register('formats/video', _CustomVideoBlot.default);
_reactQuill.Quill.register('formats/substitutionVariables', _SubstitutionVariablesBlot.default);
_reactQuill.Quill.register(LinkTarget, true);
var icons = _reactQuill.Quill.import('ui/icons');
var defaultToolbar = [[{
  'header': ['h1', 'h2', 'h3', 'body1', 'body2', 'body3', 'caption', false]
}], ['bold', 'italic', 'underline', 'strike'], [{
  'color': ['#151618', '#5B5E65', '#00834F', '#D42828', '#BA46A6', '#7100EB']
}], [{
  'script': 'sub'
}, {
  'script': 'super'
}, 'blockquote'], [{
  align: ''
}, {
  align: 'center'
}, {
  align: 'right'
}, {
  align: 'justify'
}], [{
  'list': 'bullet'
}, {
  'list': 'ordered'
}], [{
  'indent': '-1'
}, {
  'indent': '+1'
}, {
  'direction': 'rtl'
}], ['link', 'image', 'video'], ['clean'], [{
  'history': 'undo'
}, {
  'history': 'redo'
}]];

/**
 * Gets the appropriate locale to use for translation strings in the RichTextEditor
 * style menus.
 *
 * @param {string} locale The current locale
 * @returns {string}      The translation locale
 */
var getTranslationLocale = function getTranslationLocale(locale) {
  if (locale != null && locale.startsWith('es')) {
    return 'es';
  } else {
    return locale;
  }
};

/**
 * A component that enables users to create rich textual content.
 * @done true
 * @updated v7.18.0
 * @versionAdded v7.2.0
 * @examples
 *  RichTextEditorExample
 *  InADialog
 *  WithCustomToolbar
 *  MinimumHeight
 *  WithRichTextRenderer
 */
var RichTextEditor = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(false),
    iconsLoaded = _useState[0],
    setIconsLoaded = _useState[1];
  var className = props.className,
    toolbarProp = props.toolbar,
    edsContext = props.edsContext,
    disableLinkTargets = props.disableLinkTargets,
    readOnly = props.readOnly,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var dir = edsContext.dir;
  var quillRef = ref || (0, _react.useRef)(); //eslint-disable-line react-hooks/rules-of-hooks

  /**
   * the classes prop will override the following keys:
   *      - root (editor specific class)
   *      - translations (editor specific class)
   *      - renderer (renderer specific class)
   */
  var editorClasses = (0, _useEditorStyles.default)(props); //  we will only use the classes root, rtl, and translations
  var rendererClasses = (0, _useRendererStyles.default)(props); // we will only use the class renderer

  var renderToHTML = (0, _react.useCallback)(function (Component) {
    return new Promise(function (resolve) {
      var span = document.createElement('span');
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(Component, {
        dir: dir
      }), span, function () {
        var html = span.innerHTML;
        span.remove();
        resolve(html);
      });
    });
  }, [dir]);
  (0, _react.useEffect)(function () {
    (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
      var alignHTML, alignCenterHTML, alignJustifyHTML, alignRightHTML, blockquoteHTML, boldHTML, clearFormattingHTML, directionHTML, directionRTLHTML, fontColorHTML, imageHTML, indentHTML, italicHTML, linkHTML, orderedListHTML, outdentHTML, redoHTML, strikethroughHTML, superscriptHTML, subscriptHTML, underlineHTML, undoHTML, unorderedListHTML, videoHTML, substitutionVariableHTML;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return renderToHTML(_AlignLeft.default);
          case 2:
            alignHTML = _context.sent;
            _context.next = 5;
            return renderToHTML(_AlignCenter.default);
          case 5:
            alignCenterHTML = _context.sent;
            _context.next = 8;
            return renderToHTML(_AlignJustify.default);
          case 8:
            alignJustifyHTML = _context.sent;
            _context.next = 11;
            return renderToHTML(_AlignRight.default);
          case 11:
            alignRightHTML = _context.sent;
            _context.next = 14;
            return renderToHTML(_QuoteRight.default);
          case 14:
            blockquoteHTML = _context.sent;
            _context.next = 17;
            return renderToHTML(_Bold.default);
          case 17:
            boldHTML = _context.sent;
            _context.next = 20;
            return renderToHTML(_ClearFormatting.default);
          case 20:
            clearFormattingHTML = _context.sent;
            _context.next = 23;
            return renderToHTML(_Direction.default);
          case 23:
            directionHTML = _context.sent;
            _context.next = 26;
            return renderToHTML(_DirectionRtl.default);
          case 26:
            directionRTLHTML = _context.sent;
            _context.next = 29;
            return renderToHTML(_Font.default);
          case 29:
            fontColorHTML = _context.sent;
            _context.next = 32;
            return renderToHTML(_Image.default);
          case 32:
            imageHTML = _context.sent;
            _context.next = 35;
            return renderToHTML(_Indent.default);
          case 35:
            indentHTML = _context.sent;
            _context.next = 38;
            return renderToHTML(_Italic.default);
          case 38:
            italicHTML = _context.sent;
            _context.next = 41;
            return renderToHTML(_Link.default);
          case 41:
            linkHTML = _context.sent;
            _context.next = 44;
            return renderToHTML(_ListOl.default);
          case 44:
            orderedListHTML = _context.sent;
            _context.next = 47;
            return renderToHTML(_Outdent.default);
          case 47:
            outdentHTML = _context.sent;
            _context.next = 50;
            return renderToHTML(_Redo.default);
          case 50:
            redoHTML = _context.sent;
            _context.next = 53;
            return renderToHTML(_Strikethrough.default);
          case 53:
            strikethroughHTML = _context.sent;
            _context.next = 56;
            return renderToHTML(_Superscript.default);
          case 56:
            superscriptHTML = _context.sent;
            _context.next = 59;
            return renderToHTML(_Subscript.default);
          case 59:
            subscriptHTML = _context.sent;
            _context.next = 62;
            return renderToHTML(_Underline.default);
          case 62:
            underlineHTML = _context.sent;
            _context.next = 65;
            return renderToHTML(_Undo.default);
          case 65:
            undoHTML = _context.sent;
            _context.next = 68;
            return renderToHTML(_ListView.default);
          case 68:
            unorderedListHTML = _context.sent;
            _context.next = 71;
            return renderToHTML(_Video.default);
          case 71:
            videoHTML = _context.sent;
            _context.next = 74;
            return renderToHTML(_VariableData.default);
          case 74:
            substitutionVariableHTML = _context.sent;
            icons.align['right'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignRight') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignRight') + "\">" + alignRightHTML + "</span>";
            icons.align['center'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignCenter') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignCenter') + "\">" + alignCenterHTML + "</span>";
            icons.align['justify'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignJustify') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignJustify') + "\">" + alignJustifyHTML + "</span>";
            icons.align[''] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignLeft') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignLeft') + "\">" + alignHTML + "</span>";
            icons.blockquote = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.blockquote') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.blockquote') + "\">" + blockquoteHTML + "</span>";
            icons.bold = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.bold') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.bold') + "\">" + boldHTML + "</span>";
            icons.color = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.textColor') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.textColor') + "\">" + fontColorHTML + "</span>";
            icons.clean = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.clearFormatting') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.clearFormatting') + "\">" + clearFormattingHTML + "</span>";
            icons.direction.rtl = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\">" + directionHTML + "</span>";
            icons.direction[''] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\">" + directionRTLHTML + "</span>";
            icons.image = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.image') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.image') + "\">" + imageHTML + "</span>";
            icons.indent['+1'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.indent') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.indent') + "\">" + indentHTML + "</span>";
            icons.indent['-1'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.outdent') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.outdent') + "\">" + outdentHTML + "</span>";
            icons.italic = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.italic') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.italic') + "\">" + italicHTML + "</span>";
            icons.link = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.link') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.link') + "\">" + linkHTML + "</span>";
            icons.list.bullet = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.listUnordered') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.listUnordered') + "\">" + unorderedListHTML + "</span>";
            icons.list.ordered = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.listNumbered') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.listNumbered') + "\">" + orderedListHTML + "</span>";
            icons.history = {
              redo: "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.redo') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.redo') + "\">" + redoHTML + "</span>"
            };
            icons.script.sub = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.subscript') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.subscript') + "\">" + subscriptHTML + "</span>";
            icons.script.super = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.superscript') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.superscript') + "\">" + superscriptHTML + "</span>";
            icons.strike = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.strikethrough') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.strikethrough') + "\">" + strikethroughHTML + "</span>";
            icons.underline = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.underline') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.underline') + "\">" + underlineHTML + "</span>";
            icons.history.undo = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.undo') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.undo') + "\">" + undoHTML + "</span>";
            icons.video = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.video') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.video') + "\">" + videoHTML + "</span>";
            icons.substitutionVariables = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.variableData') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.variableData') + "\">" + substitutionVariableHTML + "</span>";
            setIconsLoaded(true);
          case 101:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }, [edsContext, renderToHTML]);
  var containerRef = (0, _react.useRef)();

  // This code is from eee-dashboard; this automatically sets the editor to RTL if the context dir is RTL
  // This will only flip the direction of the first line within the quill editor
  // This function will not run when value or defaultValue exists
  (0, _react.useEffect)(function () {
    if (dir === 'rtl' && !props.defaultValue && !props.value) {
      var _containerRef$current;
      var directionButton = containerRef == null || (_containerRef$current = containerRef.current) == null ? void 0 : _containerRef$current.querySelector('.ql-direction');
      directionButton == null || directionButton.click();
    }
  }, [dir, props.defaultValue, props.value]);

  // Changes the text alignment format button when the text direction button is not present
  (0, _react.useEffect)(function () {
    var _containerRef$current2, _containerRef$current4;
    if (dir === 'rtl' && !(containerRef != null && (_containerRef$current2 = containerRef.current) != null && _containerRef$current2.querySelector('.ql-direction'))) {
      var _containerRef$current3;
      var rightAlignButton = containerRef == null || (_containerRef$current3 = containerRef.current) == null ? void 0 : _containerRef$current3.querySelector('.ql-align[value="right"]');
      rightAlignButton == null || rightAlignButton.click();
    } else if (dir === 'ltr' && !(containerRef != null && (_containerRef$current4 = containerRef.current) != null && _containerRef$current4.querySelector('.ql-direction'))) {
      var _containerRef$current5;
      var leftAlignButton = containerRef == null || (_containerRef$current5 = containerRef.current) == null ? void 0 : _containerRef$current5.querySelector('.ql-align[value=""]');
      leftAlignButton == null || leftAlignButton.click();
    }
  }, [dir]);

  /* #region link start */
  var _useState2 = (0, _react.useState)(false),
    isLinkPopperOpen = _useState2[0],
    setLinkPopperOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    linkText = _useState3[0],
    setLinkText = _useState3[1];
  var _useState4 = (0, _react.useState)(''),
    linkURL = _useState4[0],
    setLinkURL = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    linkTarget = _useState5[0],
    setLinkTarget = _useState5[1];
  var _useState6 = (0, _react.useState)(),
    returnEditorFocus = _useState6[0],
    setReturnEditorFocus = _useState6[1];
  function linkHandler() {
    var _linkFormats$link, _linkFormats, _linkFormats$target, _linkFormats2;
    var selection = this.quill.getSelection();
    var linkFormats = {};

    // get the link format of the selected range if there is a selection
    if (selection.length > 0) {
      // getFormat() will return arrays for the format properties if multiple links (or other formats) are selected
      linkFormats = this.quill.getFormat();

      // if a format is an array, keep only the first item
      for (var format in linkFormats) {
        if (Array.isArray(linkFormats[format]) && linkFormats[format].length > 0) {
          linkFormats[format] = linkFormats[format][0];
        }
      }
    }
    setLinkText(this.quill.getText(selection.index, selection.length));
    setLinkURL((_linkFormats$link = (_linkFormats = linkFormats) == null ? void 0 : _linkFormats.link) != null ? _linkFormats$link : '');
    setLinkTarget((_linkFormats$target = (_linkFormats2 = linkFormats) == null ? void 0 : _linkFormats2.target) != null ? _linkFormats$target : '');

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());
    setLinkPopperOpen(true);
  }
  var setLinkUrl = function setLinkUrl(link) {
    // get the editor and selection range
    var editor = quillRef.current.getEditor();
    var selection = editor.getSelection(true);

    // if there is no selection, add the link to the editor
    if (selection.length === 0) {
      // use the url as the link text if no text is provided
      if (!link.title) {
        link.title = link.url;
      }
      editor.insertText(selection.index, link.title, {
        'link': link.url,
        'target': link.target
      }, _reactQuill.Quill.sources.USER);
    } else {
      // remove any existing link from the selected text
      editor.format('link', false, _reactQuill.Quill.sources.USER);
      editor.format('target', false, _reactQuill.Quill.sources.USER);

      // get the selected text from the selection range
      var selectedText = editor.getText(selection.index, selection.length);

      // if the selected text changed, remove the selection and replace it
      if (selectedText !== link.title) {
        editor.deleteText(selection.index, selection.length, _reactQuill.Quill.sources.USER);
        editor.insertText(selection.index, link.title, {
          'link': link.url,
          'target': link.target
        }, _reactQuill.Quill.sources.USER);
      } else {
        // else format the selection with a link
        editor.formatText(selection.index, selection.length, {
          'link': link.url,
          'target': link.target
        }, _reactQuill.Quill.sources.USER);
      }
    }
    editor.setSelection(selection.index, link.title.length);
    closeLinkPopper();
  };
  var closeLinkPopper = function closeLinkPopper() {
    setLinkPopperOpen(false);
    setLinkURL('');
    setLinkText('');
    setLinkTarget('');

    // return focus back to the editor if the user cancels the popper
    if (returnEditorFocus && !isImagePopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };

  /* #region link end */

  /* #region image start */
  var _useState7 = (0, _react.useState)(false),
    isImagePopperOpen = _useState7[0],
    setImagePopperOpen = _useState7[1];
  var _useState8 = (0, _react.useState)(''),
    imageAltText = _useState8[0],
    setImageAltText = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    imageURL = _useState9[0],
    setImageURL = _useState9[1];
  var _useState10 = (0, _react.useState)(''),
    imageLinkURL = _useState10[0],
    setImageLinkURL = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    imageLinkTarget = _useState11[0],
    setImageLinkTarget = _useState11[1];
  function imageHandler() {
    var _imageFormats$alt, _imageFormats, _imageFormats$imageSr, _imageFormats2, _imageFormats$link, _imageFormats3, _imageFormats$target, _imageFormats4;
    var selection = this.quill.getSelection();
    var imageFormats = {};

    // get the image format of the selected image if there is a selection
    if (selection.length === 1) {
      imageFormats = this.quill.getFormat();
    }

    // use default values for format attributes if they are not present
    setImageAltText((_imageFormats$alt = (_imageFormats = imageFormats) == null ? void 0 : _imageFormats.alt) != null ? _imageFormats$alt : '');
    setImageURL((_imageFormats$imageSr = (_imageFormats2 = imageFormats) == null ? void 0 : _imageFormats2.imageSrc) != null ? _imageFormats$imageSr : '');
    setImageLinkURL((_imageFormats$link = (_imageFormats3 = imageFormats) == null ? void 0 : _imageFormats3.link) != null ? _imageFormats$link : '');
    setImageLinkTarget((_imageFormats$target = (_imageFormats4 = imageFormats) == null ? void 0 : _imageFormats4.target) != null ? _imageFormats$target : '');

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());
    setImagePopperOpen(true);
  }
  var setImage = function setImage(image) {
    // get the selection range in the editor
    var editor = quillRef.current.getEditor();
    var selection = editor.getSelection(true);

    // if the selection length is 0, insert the image
    if (selection.length === 0) {
      // insert the image
      editor.insertEmbed(selection.index, 'image', {
        alt: image.altText,
        url: image.url
      }, _reactQuill.Quill.sources.USER);
    } else if (selection.length > 0) {
      // getFormat() will return arrays for the format properties if multiple images are selected
      var selectedFormat = editor.getFormat();

      // if the current selection is only 1 image and the src url didn't change, format the image
      // else delete the current selection and insert the new image
      // when the image src changes, we don't want to keep the other image attributes/formats like 'width'
      if (selection.length === 1 && Object.hasOwn(selectedFormat, 'imageSrc') && selectedFormat.imageSrc === image.url) {
        editor.format('alt', image.altText, _reactQuill.Quill.sources.USER);
      } else {
        editor.deleteText(selection.index, selection.length, _reactQuill.Quill.sources.USER);
        editor.insertEmbed(selection.index, 'image', {
          alt: image.altText,
          url: image.url
        }, _reactQuill.Quill.sources.USER);
      }
    }

    // if a link is added to the image in the popper, format the image with a link
    // since any additional selected content would be deleted at this point and replaced with the image
    // we don't need to check for selection length or formatting
    if (image.linkUrl) {
      // format the image link
      editor.formatText(selection.index, 1, {
        'link': image.linkUrl,
        'target': image.linkTarget
      }, _reactQuill.Quill.sources.USER);
    } else {
      // else remove the link
      editor.setSelection(selection.index, 1, _reactQuill.Quill.sources.USER);
      editor.format('link', false, _reactQuill.Quill.sources.USER);
      editor.format('target', false, _reactQuill.Quill.sources.USER);
    }

    // remove the selection
    editor.setSelection(selection.index + 1, 0, _reactQuill.Quill.sources.USER);
    closeImagePopper();
  };
  var closeImagePopper = function closeImagePopper() {
    setImagePopperOpen(false);
    setImageURL('');
    setImageAltText('');

    // return focus back to the editor once the popper is closed
    if (returnEditorFocus && !isLinkPopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };
  /* #region image end */

  /* #region video start */
  var _useState12 = (0, _react.useState)(false),
    isVideoPopperOpen = _useState12[0],
    setVideoPopperOpen = _useState12[1];
  var _useState13 = (0, _react.useState)(''),
    videoTitle = _useState13[0],
    setVideoTitle = _useState13[1];
  var _useState14 = (0, _react.useState)(''),
    videoURL = _useState14[0],
    setVideoURL = _useState14[1];
  function videoHandler() {
    var _videoFormats$title, _videoFormats, _videoFormats$videoSr, _videoFormats2;
    var selection = this.quill.getSelection();
    var videoFormats = {};
    if (selection.length === 1) {
      videoFormats = this.quill.getFormat();
    }
    setVideoTitle((_videoFormats$title = (_videoFormats = videoFormats) == null ? void 0 : _videoFormats.title) != null ? _videoFormats$title : '');
    setVideoURL((_videoFormats$videoSr = (_videoFormats2 = videoFormats) == null ? void 0 : _videoFormats2.videoSrc) != null ? _videoFormats$videoSr : '');

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());
    setVideoPopperOpen(true);
  }
  var setVideo = function setVideo(video) {
    // get the selection range in the editor
    var editor = quillRef.current.getEditor();
    var selection = editor.getSelection(true);

    // if the selection length is 0, insert the video
    if (selection.length === 0) {
      // insert the image
      editor.insertEmbed(selection.index, 'video', {
        title: video.title,
        url: video.url
      }, _reactQuill.Quill.sources.USER);
    } else if (selection.length > 0) {
      // getFormat() will return arrays for the format properties if multiple videos are selected
      var selectedFormat = editor.getFormat();

      // if the current selection is only 1 video and the src url didn't change, format the video
      // else delete the current selection and insert the new video
      // when the video src changes, we don't want to keep the other video attributes/formats
      if (selection.length === 1 && Object.hasOwn(selectedFormat, 'videoSrc') && selectedFormat.videoSrc === video.url) {
        editor.format('title', video.title, _reactQuill.Quill.sources.USER);
      } else {
        editor.deleteText(selection.index, selection.length, _reactQuill.Quill.sources.USER);
        editor.insertEmbed(selection.index, 'video', {
          title: video.title,
          url: video.url
        }, _reactQuill.Quill.sources.USER);
      }
    }
    closeVideoPopper();
  };
  var closeVideoPopper = function closeVideoPopper() {
    setVideoPopperOpen(false);
    setVideoURL('');
    setVideoTitle('');

    // return focus back to the editor once the popper is closed
    if (returnEditorFocus && !isVideoPopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };

  /* #region video end */

  /* #region substitution variables start */
  var _useState15 = (0, _react.useState)(false),
    isSubstitutionVariablesPopperOpen = _useState15[0],
    setSubstitutionVariablesPopperOpen = _useState15[1];
  var _useState16 = (0, _react.useState)(),
    substitutionVariablePlaceholder = _useState16[0],
    setSubstitutionVariablesPlaceholder = _useState16[1];
  function substitutionVariablesHandler() {
    var _substitutionVariable;
    var selection = this.quill.getSelection();
    var substitutionVariablesFormats = {};
    if (selection.length === 1) {
      substitutionVariablesFormats = this.quill.getFormat();
    }
    // Define and initialize the substitution variable
    var variable = (_substitutionVariable = substitutionVariablesFormats['data-variable']) != null ? _substitutionVariable : '';

    // Use the substitution variable in your JSX
    if (variable) {
      setSubstitutionVariablesPlaceholder(variable);
    }

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());
    setSubstitutionVariablesPopperOpen(true);
  }
  var setSubstitutionVariable = function setSubstitutionVariable(substitutionVariable) {
    // get the selection range in the editor
    var editor = quillRef.current.getEditor();
    var selection = editor.getSelection(true);

    // if the selection length is 0, insert the substitutionVariable
    if (selection.length === 0) {
      // insert the variable
      editor.insertEmbed(selection.index, 'substitutionVariables', {
        variable: substitutionVariable.variable
      }, _reactQuill.Quill.sources.USER);
    } else {
      editor.format('data-variable', substitutionVariable.variable);
    }
    editor.setSelection(selection.index + 1, 0, _reactQuill.Quill.sources.USER);
    closeSubstitutionVariablesPopper();
  };
  var closeSubstitutionVariablesPopper = function closeSubstitutionVariablesPopper() {
    setSubstitutionVariablesPopperOpen(false);
    setSubstitutionVariablesPlaceholder('');

    // return focus back to the editor once the popper is closed
    if (returnEditorFocus && !isSubstitutionVariablesPopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };
  /* #region substitution variables end */

  /* #region autoformatLinks start */
  var urlPattern = /(?:\s|^)(https?:\/\/[^\s]+)/;
  var globalUrlPattern = /https?:\/\/[^\s]+/g;
  var sliceUrl = function sliceUrl(url) {
    // slice url at the last instance of any whitespace
    var index = url.lastIndexOf(' ');
    var sliceIndex = index === -1 ? 0 : index + 1;
    var slicedUrl = url.slice(sliceIndex);
    return slicedUrl;
  };
  var bindings = {
    autoLinksSpace: {
      collapsed: true,
      key: ' ',
      prefix: urlPattern,
      // prefix matches the text immediately preceding the user’s selection’s start position
      handler: function handler(range, context) {
        // get the url from context.prefix
        var url = sliceUrl(context.prefix);

        // retain the contents after the sliced whitespace
        var retain = range.index - url.length;

        // add operations for formatting the url into a hyperlink
        var delta = new _quillDelta.default().retain(retain).delete(url.length).insert(url, {
          link: url
        });
        this.quill.updateContents(delta, _reactQuill.Quill.sources.USER);

        // updateContents uses Quill's Delta API to batch update contents
        this.quill.updateContents(delta);
        return true; // returning true allows other handlers to propagate
      }
    },
    autoLinksEnter: {
      collapsed: true,
      key: 'Enter',
      prefix: urlPattern,
      // prefix matches the text immediately preceding the user’s selection’s start position
      handler: function handler(range, context) {
        // get the url from context.prefix
        var url = sliceUrl(context.prefix);

        // retain the contents after the sliced whitespace
        var retain = range.index - url.length;

        // add operations for formatting the url into a hyperlink
        var delta = new _quillDelta.default().retain(retain).delete(url.length).insert(url, {
          link: url
        });
        this.quill.updateContents(delta, _reactQuill.Quill.sources.USER);

        // updateContents uses Quill's Delta API to batch update contents
        this.quill.updateContents(delta);
        return true; // returning true allows other handlers to propagate
      }
    },
    tab: {
      // must be named tab in order to override Quill's default tab handler
      key: 'Tab',
      handler: function handler(range, context) {
        // part of Quill's default tab handler
        if (context.format.table) {
          return true;
        }
        if (urlPattern.test(context.prefix)) {
          // get the url from context.prefix
          var url = sliceUrl(context.prefix);

          // retain the contents after the sliced whitespace
          var retain = range.index - url.length;

          // add operations for formatting the url into a hyperlink
          var delta = new _quillDelta.default().retain(retain).delete(url.length).insert(url, {
            link: url
          }).insert('\t');
          this.quill.updateContents(delta, _reactQuill.Quill.sources.USER);
        } else {
          // Quill's default tab handler
          this.quill.history.cutoff();
          var _delta = new _quillDelta.default().retain(range.index).delete(range.length).insert('\t');
          this.quill.updateContents(_delta, _reactQuill.Quill.sources.USER);
          this.quill.history.cutoff();
          this.quill.setSelection(range.index + 1, _reactQuill.Quill.sources.SILENT);
          return false;
        }
      }
    }
  };

  /**
   * Interprets pasted clipboard and matches the contents to automatically convert URLs into hyperlinks
   * @param {*} node DOM Node of the parsed HTML contents from the clipboard
   * @param {*} delta Delta object with the list of editor operations to paste the respective node
   * @returns delta - delta param with updated operations if a url is present in the contents
   */
  var autoLinkClipboard = function autoLinkClipboard(node, delta) {
    // skip if node is not text
    if (typeof node.data !== 'string') {
      return;
    }

    // globally match all the urls in the clipboard text
    var matches = node.data.match(globalUrlPattern);
    if (matches && matches.length > 0) {
      var operations = [];
      var str = node.data;
      matches.forEach(function (match) {
        // split the matched text
        var split = str.split(match);
        var beforeLink = split.shift();

        // add operations for formatting the url into a hyperlink
        operations.push({
          insert: beforeLink
        });
        operations.push({
          insert: match,
          attributes: {
            link: match
          }
        });
        str = split.join(match);
      });
      operations.push({
        insert: str
      });
      delta.ops = operations;
    }
    return delta;
  };

  /**
   * Interprets pasted hyperlinks to ensure the target attribute is added to the link
   * @param {*} node DOM Node of the parsed HTML contents from the clipboard
   * @param {*} delta Delta object with the list of editor operations to paste the respective node
   * @returns delta - delta param with updated operations if a target is added to the link
   */
  var linkMatcher = function linkMatcher(node, delta) {
    if (node.getAttribute('target')) {
      // search the list of delta operations for a link
      delta.ops.forEach(function (operation, index) {
        if (operation != null && operation.attributes && 'link' in operation.attributes) {
          // add the hyperlink's target to the list of link attributes in the delta operation
          if (typeof operation.attributes.link === 'object') {
            delta.ops[index].attributes.link['target'] = node.getAttribute('target');
          } else {
            delta.ops[index].attributes.link = {
              href: node.getAttribute('href'),
              target: node.getAttribute('target')
            };
          }
        }
      });
    }
    return delta;
  };
  /* #region autoformatLinks end */

  /* #region undo/redo start */
  function historyHandler(value) {
    // value is from the key-value pair used to define the toolbar button
    if (value === 'undo') {
      // undoes the last operation; operation source is USER
      this.quill.history.undo();
    } else if (value === 'redo') {
      // redoes the last operation; operation source is USER
      this.quill.history.redo();
    }
  }
  /* #region undo/redo end */

  var modules = (0, _react.useMemo)(function () {
    var toolbar = {
      container: toolbarProp || defaultToolbar,
      handlers: {
        link: linkHandler,
        image: imageHandler,
        video: videoHandler,
        history: historyHandler,
        substitutionVariables: substitutionVariablesHandler
      }
    };
    var localModules = {
      toolbar: toolbar,
      keyboard: {
        bindings: bindings
      },
      // ReactQuill calls the clipboard API on initial render to set the contents of the editor
      // this means that any matchers or clipboard configuration options will apply on initial render
      clipboard: {
        matchers: [[Node.TEXT_NODE, autoLinkClipboard], ['a', linkMatcher]],
        /**
         * This configuration option is not found in the Quill public documentation site
         * see https://github.com/quilljs/quill/blob/1.3.7/docs/docs/modules/clipboard.md#matchvisual
         *
         * Overrides Quill's "visual" interpretation of margin and padding from pasted text to use the
         * exact HTML value. Prevents line-break duplication on initial render.
         */
        matchVisual: false
      }
    };

    // disable image resizing when in read-only mode
    if (!readOnly) {
      localModules.imageResize = {
        modules: ['Resize', 'DisplaySize']
      };
    }
    return localModules;
  }, [readOnly]);
  return iconsLoaded && /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_reactQuill.default, (0, _extends2.default)({
    ref: quillRef,
    className: (0, _classnames.default)(className, editorClasses.root, editorClasses.translations, rendererClasses.root, "ql-locale-" + getTranslationLocale(edsContext.locale), {
      'ql-snow-rtl': dir === 'rtl'
    }),
    theme: "snow",
    modules: modules,
    readOnly: readOnly
  }, rest)), /*#__PURE__*/_react.default.createElement(_LinkPopper.default, {
    isPopperOpen: isLinkPopperOpen,
    onInsertLink: setLinkUrl,
    onClose: closeLinkPopper,
    title: linkText,
    url: linkURL,
    target: linkTarget,
    disableLinkTargets: disableLinkTargets,
    isEdit: !(linkText === '' && linkURL === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }), /*#__PURE__*/_react.default.createElement(_ImagePopper.default, {
    isPopperOpen: isImagePopperOpen,
    onInsertImage: setImage,
    onClose: closeImagePopper,
    altText: imageAltText,
    url: imageURL,
    linkUrl: imageLinkURL,
    linkTarget: imageLinkTarget,
    disableLinkTargets: disableLinkTargets,
    isEdit: !(imageAltText === '' && imageURL === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }), /*#__PURE__*/_react.default.createElement(_VideoPopper.default, {
    isPopperOpen: isVideoPopperOpen,
    onInsertVideo: setVideo,
    onClose: closeVideoPopper,
    title: videoTitle,
    url: videoURL,
    isEdit: !(videoTitle === '' && videoURL === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }), /*#__PURE__*/_react.default.createElement(_SubstitutionVariablesPopper.default, {
    isPopperOpen: isSubstitutionVariablesPopperOpen,
    onInsertSubstitutionVariable: setSubstitutionVariable,
    onClose: closeSubstitutionVariablesPopper,
    variable: substitutionVariablePlaceholder || '',
    substitutionVariableList: props.substitutionVariableList || [],
    isEdit: !(substitutionVariablePlaceholder === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }));
});
RichTextEditor.displayName = 'RichTextEditor';
RichTextEditor.propTypes = {
  /**
   * Override or extend the styles applied to the component.
  */
  classes: _propTypes.default.object,
  /**
      * The HTML `id` to be applied to the DOM element.
  */
  id: _propTypes.default.string,
  /**
   * Class name to be applied to the DOM element.
   */
  className: _propTypes.default.string,
  /**
   * Initial value for the editor as an uncontrolled component. Can be a string containing HTML.
   */
  defaultValue: _propTypes.default.string,
  /**
   * @ignore
  */
  edsContext: _propTypes.default.object,
  /**
   * An array specifying the toolbar options.
  */
  toolbar: _propTypes.default.array,
  /**
   * (content)
   *
   * Called back with the new contents of the editor after change. It will be passed the HTML contents of the editor.
   */
  onChange: _propTypes.default.func,
  /**
   * The default value for the empty editor.
   *
   * Note: We do not support changing this value dynamically. Use refs and data-attributes instead (see Developers Notes, above, for details)
   */
  placeholder: _propTypes.default.string,
  /**
   * An array of substitution variable items with a value and a label. The value is used as the inserted value into the rich text editor in the format {{value}}. The label is used as the display value shown in the dropdown.
   */
  substitutionVariableList: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })),
  /**
   * If `true`, the `target` attribute will not be available to edit in the link or image link popups.
   */
  disableLinkTargets: _propTypes.default.bool,
  /**
   * If `true`, a `pre` tag is used for the editor area instead of the default `div` tag.
   *
   * This prevents the Rich Text Editor from collapsing continuous whitespaces on paste.
   */
  preserveWhitespace: _propTypes.default.bool,
  /**
   * If `true`, the editor won't allow changing its contents.
   */
  readOnly: _propTypes.default.bool,
  /**
   * An object with custom CSS rules to apply on the editor's container.
   */
  style: _propTypes.default.object,
  /**
   * The order in which the editor becomes focused, among other controls in the page, during keyboard navigation.
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * @ignore
   * The name of the theme to apply to the editor. Defaults to `snow`, Quill's standard theme.
   * Pass `null` to use the minimal core theme. See the docs on themes for more information on
   * including the required stylesheets.
   */
  theme: _propTypes.default.string,
  /**
   * Value for the editor as a controlled component. Can be a string containing HTML
   */
  value: _propTypes.default.any
};
RichTextEditor.defaultProps = {
  disableLinkTargets: false,
  preserveWhitespace: false,
  readOnly: false
};
var _default = exports.default = (0, _EDSContext.withEDSContext)(RichTextEditor);